import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="about-container">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>

      <p className="mb-4">
        At <strong>jsonconverter.org</strong>, your privacy is important to us. We respect your data and want to be transparent about how we operate.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">No Personal Data Storage</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>No user information is collected or stored by us.</strong></li>
        <li>Our site does not require login, registration, or personal details.</li>
        <li>All tools work directly in your browser, and no data is saved permanently on our servers.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Cloudflare Hosting</h2>
      <p className="mb-4">
        jsonconverter.org is hosted and secured through <strong>Cloudflare</strong>.
        Cloudflare may collect certain technical data such as your IP address, browser type, operating system, and usage data for security, performance, and analytics purposes.
      </p>
      <p className="mb-4">
        This data is controlled by Cloudflare under its own Privacy Policy.
        For details, visit:{" "}
        <a
          href="https://www.cloudflare.com/privacypolicy/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          Cloudflare Privacy Policy
        </a>.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">No User Tracking</h2>
      <p className="mb-4">
        We do not track or profile users. We do not use cookies for personal identification purposes.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Google Ads</h2>
      <p className="mb-4">
        Our website displays ads via <strong>Google AdSense</strong> to support the platform.
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Google may use cookies and similar technologies to show relevant ads.</li>
        <li>This is controlled by Google’s own Privacy Policy.</li>
      </ul>
      <p>
        For more details, visit:{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          Google Privacy Policy
        </a>.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Third-Party Services</h2>
      <p className="mb-4">
        We use Google AdSense and Cloudflare. Other than these, we do not use third-party services that collect personal data.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Security</h2>
      <p className="mb-4">
        We implement standard security measures to protect the site and ensure safe browsing.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Changes to Privacy Policy</h2>
      <p className="mb-4">
        We may update this policy occasionally. Changes will be posted here.
      </p>

      {/* <h2 className="text-2xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p>
        For questions about this Privacy Policy, contact us at:{" "}
        <a href="mailto:contact@jsonconverter.org" className="text-blue-600 underline">
          contact@jsonconverter.org
        </a>.
      </p>  */}
    </div>
  );
};

export default PrivacyPolicy;
